<template>
    <Breadcrumbs main="LANDING" mains="NEWS" :title="`${web_use}`" />
    <News />
</template>
<script lang="ts" setup>
import { defineAsyncComponent } from 'vue'
const News = defineAsyncComponent(() => import("@/pages/news/Index.vue"))
const web_use = import.meta.env.VITE_APP_TITLE
</script>
